import React from 'react'
import AdvancedSearch from '../advanced-search'

const AdvancedSearchFr = () => {
    return <AdvancedSearch languageCode="fr" />
}

export default AdvancedSearchFr
